export const tutorUrl = '/tutor';
export const isTutorRoute = window.location.href.indexOf(tutorUrl) !== -1;

export const isTutorLessonRoute = /^\/tutor\/(?!index$).+$/.test(window.location.pathname);
